import React from 'react';
import './AvancementMois.css';

// ─── « Où en est le mois » — un seul bloc pour les six rapports quotidiens ───
// La question est la même partout : à ce stade du mois, suis-je en avance ou en
// retard ? Seul le REPÈRE change — un objectif saisi pour l'APV, le mois
// précédent pour les ventes, qui n'en ont aucun. Le bloc nomme son repère, pour
// qu'on ne lise pas l'un pour l'autre.
//
// ⚠ Le libellé était écrit DANS la barre, en blanc avec `mix-blend-mode:
// difference`. Sur la portion non remplie — un fond presque blanc — la
// différence rendait un texte quasi invisible. Les libellés sont désormais
// dehors, en couleur de texte normale : c'est ce qui se lit, la barre ne fait
// que situer.
//
// ⚠ Le rythme attendu n'est pas la part des jours écoulés : un mois ne se
// remplit pas linéairement. Il vient de la courbe des douze mois clos ; sans
// historique on le dit « estimé ».

export default function AvancementMois({
  realise, cible, attendu, repere, article = 'du', jours, joursRepere, fmt, projection, estime,
}) {
  if (!cible) return null;
  const part = (realise / cible) * 100;
  const avance = attendu != null ? part - attendu : null;
  const proj = projection != null ? projection : (attendu ? realise / (attendu / 100) : null);
  const ecart = proj != null ? ((proj - cible) / cible) * 100 : null;

  return (
    <div className="am">
      <div className="am-gauche">
        <div className="am-chiffre">
          <b>{Math.round(part)} %</b> {article}{article.endsWith("'") ? '' : ' '}{repere}
          {avance != null && (
            <span className={`am-etat ${avance >= 0 ? 'ok' : 'ko'}`}>
              {avance >= 0 ? '▲' : '▼'} {Math.abs(Math.round(avance))} pts vs le rythme attendu
            </span>
          )}
        </div>
        <div className="am-rail">
          <i style={{ width: `${Math.max(0, Math.min(100, part))}%` }} />
          {attendu != null && <span className="am-marque" style={{ left: `${Math.min(100, attendu)}%` }} />}
        </div>
        <div className="am-leg">
          <span>{jours}</span>
          <span>{repere} <b>{fmt(cible)}</b>{joursRepere ? ` · ${joursRepere}` : ''}</span>
        </div>
      </div>
      {proj != null && (
        <div className="am-proj">
          <div className="am-proj-l">Projection fin de mois{estime ? ' (estimée)' : ''}</div>
          <div className="am-proj-v">{fmt(proj)}</div>
          <div className={`am-proj-d ${ecart >= 0 ? 'ok' : 'ko'}`}>
            {ecart >= 0 ? '▲' : '▼'} {Math.abs(Math.round(ecart))} % vs {repere}
          </div>
        </div>
      )}
    </div>
  );
}
